/* Project Veil theme — scripts */
(function () {
  'use strict';

  var PV = window.PV || {};
  var R = PV.routes || {};
  var CART_URL = R.cart || '/cart';
  var ADD_URL = (R.cartAdd || '/cart/add') + '.js';
  var CHANGE_URL = (R.cartChange || '/cart/change') + '.js';

  /* ---------------- Helpers ---------------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents || 0, 10);
    format = format || PV.moneyFormat || '€{{amount}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    function fmt(n, dec, th, dp) {
      th = th == null ? ',' : th; dp = dp == null ? '.' : dp;
      var parts = (n / 100).toFixed(dec).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th) + (parts[1] ? dp + parts[1] : '');
    }
    var v;
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': v = fmt(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': v = fmt(cents, 0, ' ', ''); break;
      default: v = fmt(cents, 2);
    }
    return match ? format.replace(match[0], v) : v;
  }

  /* ---------------- Cart ---------------- */
  var drawer = $('[data-cart-drawer]');

  function getCart() {
    return fetch(CART_URL + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function addVariant(id, qty) {
    return fetch(ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) throw new Error(d.description || d.message || 'Could not add to bag');
        return d;
      });
    });
  }

  function changeLine(key, qty) {
    return fetch(CHANGE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = count === 0; });
    $$('[data-cart-count-text]').forEach(function (el) { el.textContent = '(' + count + ')'; });
  }

  var CART_CFG = window.PVCart || {};
  var pendingCode = '';

  function rate() { return (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1; }

  /* Reward steps (up to 3) */
  function renderRewards(cart) {
    var box = $('[data-rewards]');
    if (!box) return;
    var r = rate();
    var spent = cart.items_subtotal_price;
    var steps = $$('[data-rw-step]', box);
    var max = Math.round(parseInt(box.getAttribute('data-max'), 10) * r) || 1;
    var next = null;
    steps.forEach(function (st) {
      var amt = Math.round(parseInt(st.getAttribute('data-rw-step'), 10) * r);
      var reached = spent >= amt;
      st.classList.toggle('is-reached', reached);
      if (!reached && (!next || amt < next.amt)) next = { amt: amt, label: st.getAttribute('data-rw-label') };
    });
    var text = next
      ? (CART_CFG.progressText || '').replace('[amount]', '<b>' + formatMoney(next.amt - spent) + '</b>').replace('[reward]', '<b>' + esc(next.label) + '</b>')
      : '<b>' + esc(CART_CFG.progressDone || '') + '</b>';
    $('[data-rw-text]', box).innerHTML = text;
    $('[data-rw-fill]', box).style.width = Math.min(100, (spent / max) * 100) + '%';
  }

  /* Discounts list */
  function renderDiscounts(cart) {
    var box = $('[data-cart-discounts]', drawer);
    if (!box) return;
    var rows = [];
    var lineTotals = {};
    cart.items.forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) {
        var t = (a.discount_application && a.discount_application.title) || 'Discount';
        lineTotals[t] = (lineTotals[t] || 0) + a.amount;
      });
    });
    Object.keys(lineTotals).forEach(function (t) { rows.push([t, lineTotals[t], false]); });
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      rows.push([d.title, d.total_allocated_amount, d.type === 'discount_code']);
    });
    var codes = (cart.discount_codes || []).filter(function (c) { return c.applicable; }).map(function (c) { return c.code; });
    box.innerHTML = rows.map(function (r) {
      var removable = codes.indexOf(r[0]) > -1;
      return '<div class="drawer__row drawer__row--discount"><span class="chip">' + esc(r[0]) +
        (removable ? ' <button type="button" data-remove-code aria-label="Remove code">×</button>' : '') +
        '</span><b>−' + formatMoney(r[1]) + '</b></div>';
    }).join('');
  }

  /* Hide upsell products that are already in the bag */
  function filterUpsell(cart) {
    var wrap = $('[data-cart-upsell]', drawer);
    if (!wrap) return;
    var inCart = cart.items.map(function (i) { return String(i.product_id); });
    var visible = 0;
    $$('[data-upsell-product]', wrap).forEach(function (el) {
      var hide = inCart.indexOf(el.getAttribute('data-upsell-product')) > -1;
      el.hidden = hide;
      if (!hide) visible++;
    });
    wrap.hidden = visible === 0;
  }

  function renderCart(cart) {
    updateCount(cart.item_count);
    if (!drawer) return;
    var list = $('[data-cart-items]', drawer);
    var foot = $('[data-cart-foot]', drawer);
    renderRewards(cart);
    filterUpsell(cart);
    if (!cart.items.length) {
      list.innerHTML = '<div class="drawer__empty"><p>Your bag is empty.</p><a class="btn btn--primary" href="' + esc(R.collectionsAll || '/collections/all') + '">Shop now</a></div>';
      foot.hidden = true;
      return;
    }
    foot.hidden = false;
    list.innerHTML = cart.items.map(function (it) {
      var img = it.image || '';
      var sizedImg = img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<p class="line__variant">' + esc(it.variant_title) + '</p>' : '<p class="line__variant"></p>';
      var orig = it.original_line_price > it.final_line_price ? '<s>' + formatMoney(it.original_line_price) + '</s>' : '';
      return '<div class="line" data-key="' + esc(it.key) + '">' +
        '<a class="line__img" href="' + esc(it.url) + '">' + (sizedImg ? '<img src="' + esc(sizedImg) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div><a class="line__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
          '<div class="line__qty"><button type="button" data-line-change="-1" aria-label="Decrease">−</button><span>' + it.quantity + '</span><button type="button" data-line-change="1" aria-label="Increase">+</button></div>' +
          '</div>' +
        '<div class="line__price">' + orig + '<span>' + formatMoney(it.final_line_price) + '</span>' +
          '<button type="button" class="line__remove" data-line-remove>Remove</button></div>' +
      '</div>';
    }).join('');
    renderDiscounts(cart);
    $('[data-cart-subtotal]', drawer).innerHTML = formatMoney(cart.total_price);
    var lbl = $('[data-checkout-label]', drawer);
    if (lbl) lbl.innerHTML = esc(CART_CFG.checkoutLabel || 'Checkout') + ' · ' + formatMoney(cart.total_price);
    var co = $('[data-checkout-form]', drawer);
    if (co) co.action = pendingCode ? CART_URL + '?discount=' + encodeURIComponent(pendingCode) : CART_URL;
  }

  /* Discount code field */
  function applyCode(codes, code) {
    var msg = drawer && $('[data-discount-msg]', drawer);
    return fetch(CART_URL + '/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      if (code && Array.isArray(cart.discount_codes)) {
        var found = cart.discount_codes.filter(function (c) { return c.code.toLowerCase() === code.toLowerCase(); })[0];
        pendingCode = '';
        if (msg) {
          msg.hidden = false;
          msg.textContent = found && found.applicable ? 'Code applied.' : 'This code isn\'t valid for your bag.';
        }
      } else if (code) {
        pendingCode = code; /* older cart API: apply the code at checkout instead */
        if (msg) { msg.hidden = false; msg.textContent = 'Code will be applied at checkout.'; }
      }
      renderCart(cart);
    });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-discount-form]');
    if (!f) return;
    e.preventDefault();
    var input = f.querySelector('input');
    var code = (input.value || '').trim();
    if (!code) return;
    var cart_codes = [];
    getCart().then(function (c) {
      cart_codes = (c.discount_codes || []).map(function (d) { return d.code; });
      if (cart_codes.indexOf(code) === -1) cart_codes.push(code);
      return applyCode(cart_codes.join(','), code);
    }).then(function () { input.value = ''; });
  });
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-remove-code]');
    if (!rm) return;
    var code = rm.parentElement.firstChild.textContent.trim();
    getCart().then(function (c) {
      var rest = (c.discount_codes || []).map(function (d) { return d.code; }).filter(function (x) { return x !== code; });
      return applyCode(rest.join(','), '');
    });
  });

  function openDrawer() {
    if (!drawer || PV.cartType !== 'drawer') { window.location.href = CART_URL; return; }
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
  }
  function refreshAndOpen() { return getCart().then(function (c) { renderCart(c); openDrawer(); }); }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cart-open]');
    if (opener && drawer && PV.cartType === 'drawer') { e.preventDefault(); refreshAndOpen(); return; }
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }

    var lineBtn = e.target.closest('[data-line-change], [data-line-remove]');
    if (lineBtn && drawer && drawer.contains(lineBtn)) {
      var line = lineBtn.closest('[data-key]');
      var qtyEl = $('.line__qty span', line);
      var qty = lineBtn.hasAttribute('data-line-remove') ? 0 : Math.max(0, parseInt(qtyEl.textContent, 10) + parseInt(lineBtn.getAttribute('data-line-change'), 10));
      line.style.opacity = '.5';
      changeLine(line.getAttribute('data-key'), qty).then(renderCart);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* Product form → AJAX add */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form || PV.cartType !== 'drawer') return;
    e.preventDefault();
    var buttons = $$('[data-add-button]', form).concat($$('[data-add-button][form="' + form.id + '"]'));
    var err = $('[data-form-error]', form);
    buttons.forEach(function (b) { b.classList.add('is-loading'); });
    if (err) err.hidden = true;
    fetch(ADD_URL, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Could not add to bag'); return d; }); })
      .then(refreshAndOpen)
      .catch(function (ex) { if (err) { err.textContent = ex.message; err.hidden = false; } })
      .then(function () { buttons.forEach(function (b) { b.classList.remove('is-loading'); }); });
  });

  /* Quick add on product cards */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    addVariant(btn.getAttribute('data-quick-add'), 1)
      .then(function () { btn.classList.add('is-done'); return refreshAndOpen(); })
      .catch(function (ex) { alertInline(btn, ex.message); })
      .then(function () { btn.disabled = false; });
  });
  function alertInline(el, msg) { el.title = msg; el.classList.add('has-error'); }

  /* ---------------- Upsell block ---------------- */
  document.addEventListener('click', function (e) {
    var size = e.target.closest('.pvu-size');
    var add = e.target.closest('.pvu-add');
    if (!size && !add) return;
    e.preventDefault();
    var item = (size || add).closest('[data-pvu-item]');
    var addBtn = $('.pvu-add', item);
    var msg = $('.pvu-msg', item);
    if (add && add.classList.contains('is-done')) return;
    if (add && add.getAttribute('data-multi') === 'true') {
      var sizes = $('.pvu-sizes', item);
      var open = sizes.hidden;
      sizes.hidden = !open;
      add.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    var id = size ? size.getAttribute('data-variant') : add.getAttribute('data-variant');
    addBtn.disabled = true;
    addVariant(id, 1).then(function () {
      addBtn.textContent = '✓';
      addBtn.classList.add('is-done');
      addBtn.setAttribute('aria-expanded', 'false');
      var s = $('.pvu-sizes', item); if (s) s.hidden = true;
      return getCart().then(function (c) {
        renderCart(c);
        if (msg) { msg.innerHTML = 'Added to your bag — <a href="' + esc(CART_URL) + '" data-cart-open>View bag</a>'; msg.hidden = false; }
      });
    }).catch(function (ex) {
      if (msg) { msg.textContent = ex.message; msg.hidden = false; }
    }).then(function () { addBtn.disabled = false; });
  });

  /* ---------------- Product page ---------------- */
  function initProduct(sec) {
    var jsonEl = $('[data-product-json]', sec);
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var invEl = $('[data-inventory-json]', sec);
    var inv = invEl ? JSON.parse(invEl.textContent) : {};
    var picker = $('[data-variant-picker]', sec);
    var input = $('[data-variant-input]', sec);
    var formId = sec.getAttribute('data-form-id');
    var lowAt = parseInt(sec.getAttribute('data-low-stock') || '5', 10);

    function selectedOptions() {
      return product.options.map(function (_, i) {
        var c = picker && picker.querySelector('input[data-option-index="' + i + '"]:checked');
        return c ? c.value : (product.variants[0] && product.variants[0].options[i]);
      });
    }
    function findVariant(opts) {
      return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    function markAvailability(opts) {
      if (!picker) return;
      $$('input[data-option-index]', picker).forEach(function (inp) {
        var i = parseInt(inp.getAttribute('data-option-index'), 10);
        var test = opts.slice(); test[i] = inp.value;
        var v = findVariant(test);
        var label = picker.querySelector('label[for="' + inp.id + '"]');
        if (label) label.classList.toggle('is-unavailable', !v || !v.available);
      });
    }
    function addButtons() {
      return $$('[data-add-button]', sec).concat(formId ? $$('[data-add-button][form="' + formId + '"]') : []);
    }
    function setButtons(text, disabled) {
      addButtons().forEach(function (b) {
        b.disabled = disabled;
        var t = $('[data-add-text]', b) || b;
        if (!b.hasAttribute('data-default-text')) b.setAttribute('data-default-text', t.textContent.trim());
        t.textContent = text || b.getAttribute('data-default-text');
      });
    }
    function priceHTML(v) {
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      return (sale ? '<s class="price__compare">' + formatMoney(v.compare_at_price) + '</s>' : '') +
        '<span class="price__current">' + formatMoney(v.price) + '</span>';
    }
    function updateStock(v) {
      var box = $('[data-stock]', sec);
      if (!box) return;
      var info = inv[v.id] || {};
      var cls = 'stock', text;
      if (!v.available) { cls += ' stock--out'; text = box.getAttribute('data-out'); }
      else if (info.m && info.p !== 'continue' && info.q > 0 && info.q <= lowAt) { cls += ' stock--low'; text = box.getAttribute('data-low'); }
      else { text = box.getAttribute('data-in'); }
      box.className = cls;
      $('[data-stock-text]', box).textContent = text;
    }
    function update() {
      var opts = selectedOptions();
      product.options.forEach(function (_, i) {
        var lbl = picker && picker.querySelector('[data-option-value="' + i + '"]');
        if (lbl) lbl.textContent = opts[i];
      });
      markAvailability(opts);
      var v = findVariant(opts);
      if (!v) { setButtons('Unavailable', true); return; }
      if (input) input.value = v.id;
      $$('[data-price]', sec).forEach(function (p) {
        p.innerHTML = priceHTML(v);
        p.classList.toggle('price--sale', !!(v.compare_at_price && v.compare_at_price > v.price));
      });
      setButtons(v.available ? null : 'Sold out', !v.available);
      updateStock(v);
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
      if (v.featured_media) {
        var item = sec.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        var track = $('.product__media-track', sec);
        if (item && track && window.innerWidth < 990) track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
    }
    if (picker) {
      picker.addEventListener('change', update);
      markAvailability(selectedOptions());
    }

    /* Quantity buttons */
    $$('[data-qty]', sec).forEach(function (b) {
      b.addEventListener('click', function () {
        var q = b.parentElement.querySelector('input');
        q.value = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10));
      });
    });

    /* Gallery dots (mobile) */
    var track = $('.product__media-track', sec);
    var dots = $$('.product__dots span', sec);
    if (track && dots.length) {
      dots[0].classList.add('is-active');
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
      }, { passive: true });
    }

    /* Sticky add to cart */
    var sticky = $('[data-sticky-atc]', sec);
    var mainBtn = $('.product-form__add', sec);
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(mainBtn);
    }
  }
  $$('[data-product-section]').forEach(initProduct);

  /* Open Klaviyo "Write a review" form when arriving with #pv-review */
  if (window.location.hash === '#pv-review') {
    var tries = 0;
    var t = setInterval(function () {
      var b = document.querySelector('#klaviyo-product-reviews-wrapper .kl_reviews__button, .kl_reviews__button');
      if (b) {
        clearInterval(t);
        b.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { b.click(); }, 500);
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }
      if (++tries > 40) clearInterval(t);
    }, 250);
  }

  /* ---------------- Product recommendations ---------------- */
  $$('[data-recommendations]').forEach(function (box) {
    var url = box.getAttribute('data-url');
    if (!url || box.children.length) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var fresh = tmp.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) box.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  });

  /* ---------------- Slideshow ---------------- */
  $$('[data-slideshow]').forEach(function (show) {
    var track = $('[data-slides]', show);
    var dots = $$('[data-dot]', show);
    var count = track ? track.children.length : 0;
    if (!track || count < 2) return;
    var index = 0, timer = null;
    var autoplay = show.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(show.getAttribute('data-speed') || '5', 10) * 1000;
    function go(i) { index = (i + count) % count; track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' }); }
    function mark() { dots.forEach(function (d, j) { d.classList.toggle('is-active', j === index); }); }
    track.addEventListener('scroll', function () { index = Math.round(track.scrollLeft / track.clientWidth); mark(); }, { passive: true });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-dot'), 10)); restart(); }); });
    function restart() { if (!autoplay) return; clearInterval(timer); timer = setInterval(function () { go(index + 1); }, speed); }
    show.addEventListener('mouseenter', function () { clearInterval(timer); });
    show.addEventListener('mouseleave', restart);
    track.addEventListener('touchstart', function () { clearInterval(timer); }, { passive: true });
    track.addEventListener('touchend', restart, { passive: true });
    mark(); restart();
  });

  /* ---------------- Reviews strip (auto-scroll + swipe) ---------------- */
  $$('[data-reviews-strip]').forEach(function (strip) {
    var set = $('.rv__set', strip);
    if (!set) return;
    var speed = parseFloat(strip.getAttribute('data-speed')) || 40;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var setW = 0, pos = 1, paused = false, last = null, timer = null;
    function measure() { setW = set.offsetWidth; }
    function hold() { paused = true; clearTimeout(timer); }
    function release(ms) { clearTimeout(timer); timer = setTimeout(function () { pos = strip.scrollLeft; paused = false; last = null; }, ms); }
    measure(); window.addEventListener('resize', measure); strip.scrollLeft = pos;
    strip.addEventListener('scroll', function () {
      if (!paused || !setW) return;
      var x = strip.scrollLeft;
      if (x >= setW) strip.scrollLeft = x - setW; else if (x <= 0) strip.scrollLeft = x + setW;
      pos = strip.scrollLeft;
    }, { passive: true });
    strip.addEventListener('touchstart', hold, { passive: true });
    strip.addEventListener('touchend', function () { release(2000); }, { passive: true });
    var dragging = false, moved = false, startX = 0, startScroll = 0;
    strip.addEventListener('mouseenter', hold);
    strip.addEventListener('mouseleave', function () { dragging = false; strip.classList.remove('is-dragging'); release(400); });
    strip.addEventListener('mousedown', function (e) { dragging = true; moved = false; startX = e.pageX; startScroll = strip.scrollLeft; strip.classList.add('is-dragging'); });
    window.addEventListener('mousemove', function (e) { if (!dragging) return; var dx = e.pageX - startX; if (Math.abs(dx) > 4) moved = true; strip.scrollLeft = startScroll - dx; });
    window.addEventListener('mouseup', function () { dragging = false; strip.classList.remove('is-dragging'); });
    strip.addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = false; } }, true);
    if (reduced) return;
    function frame(ts) {
      if (last === null) last = ts;
      var dt = Math.min((ts - last) / 1000, 0.1); last = ts;
      if (!setW) measure();
      if (!paused && setW) { pos += speed * dt; if (pos >= setW) pos -= setW; strip.scrollLeft = pos; }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  });

  /* Reviews "Write a review" picker */
  document.addEventListener('click', function (e) {
    var w = e.target.closest('[data-rv-write]');
    if (!w) return;
    var root = w.closest('[data-reviews]');
    var kl = document.querySelector('#klaviyo-product-reviews-wrapper .kl_reviews__button');
    if (kl) { kl.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(function () { kl.click(); }, 400); return; }
    var pick = $('[data-rv-pick]', root);
    if (!pick) return;
    pick.hidden = !pick.hidden;
    w.setAttribute('aria-expanded', pick.hidden ? 'false' : 'true');
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-rv-product]')) {
      var go = $('[data-rv-go]', e.target.closest('[data-rv-pick]'));
      if (go) go.disabled = !e.target.value;
    }
  });
  document.addEventListener('click', function (e) {
    var go = e.target.closest('[data-rv-go]');
    if (!go) return;
    var sel = $('[data-rv-product]', go.closest('[data-rv-pick]'));
    if (sel && sel.value) window.location.href = sel.value + '#pv-review';
  });
  $$('[data-reviews]').forEach(function (root) {
    var all = $('[data-rv-all]', root);
    var list = document.querySelector('.reviews_all_container, #klaviyo-product-reviews-wrapper');
    if (all && list) { all.hidden = false; all.addEventListener('click', function () { list.scrollIntoView({ behavior: 'smooth' }); }); }
  });

  /* ---------------- Facets (filters / sort) ---------------- */
  $$('[data-facets-form]').forEach(function (form) {
    function submit() {
      var params = new URLSearchParams();
      new FormData(form).forEach(function (v, k) { if (String(v).trim() !== '') params.append(k, v); });
      window.location.search = params.toString();
    }
    form.addEventListener('change', function (e) { if (e.target.type !== 'number') submit(); });
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
  });
  document.addEventListener('click', function (e) {
    $$('details[data-facet][open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  /* ---------------- Header ---------------- */
  $$('[data-autosubmit]').forEach(function (s) { s.addEventListener('change', function () { s.form.submit(); }); });

  $$('[data-hover-details]').forEach(function (d) {
    var timer;
    d.addEventListener('mouseenter', function () { if (window.innerWidth >= 990) { clearTimeout(timer); d.setAttribute('open', ''); } });
    d.addEventListener('mouseleave', function () { if (window.innerWidth >= 990) timer = setTimeout(function () { d.removeAttribute('open'); }, 150); });
  });
  document.addEventListener('click', function (e) {
    $$('[data-hover-details][open], details[data-search][open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  $$('details[data-search]').forEach(function (d) {
    d.addEventListener('toggle', function () { if (d.open) { var i = $('input[type="search"]', d); if (i) setTimeout(function () { i.focus(); }, 50); } });
  });
  $$('details[data-menu-drawer]').forEach(function (d) {
    d.addEventListener('toggle', function () { document.body.classList.toggle('no-scroll', d.open); });
  });

  /* ---------------- Reveal on scroll ---------------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { threshold: 0.15 });
    $$('[data-reveal]').forEach(function (el) {
      if (window.Shopify && Shopify.designMode) { el.classList.add('is-visible'); return; }
      io.observe(el);
    });
  } else {
    $$('[data-reveal]').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Initial cart count sync (e.g. after back navigation) */
  if (drawer) getCart().then(renderCart).catch(function () {});

  /* Theme editor: re-init when sections reload */
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-product-section]', e.target).forEach(initProduct);
  });
})();
